import _extends from '@babel/runtime/helpers/esm/extends';
import _defineProperty from '@babel/runtime/helpers/esm/defineProperty';
import React, { useMemo, useRef } from 'react';
import { get } from 'lodash';
import FocusGridManager from '@elliemae/ds-shared/FocusGroup/FocusGrid';
import { runAll } from '@elliemae/ds-utilities/utils';
import { mergeRefs } from '@elliemae/ds-utilities/system';
import createInstancePlugin from '@elliemae/ds-shared/createDataInstance/createInstancePlugin';
import VirtualizedBody from './VirtualizedBody.js';
import '@babel/runtime/helpers/esm/slicedToArray';
import 'prop-types';
import '../../components/NoResults.js';
import '@babel/runtime/helpers/esm/objectWithoutProperties';
import 'styled-components';
import '@elliemae/ds-system';
import './VirtualizedBodyRow.js';
import '../../rowSizes.js';
import './helper.js';

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
var VirtualizationPlugin = createInstancePlugin('virtualization', {
  decorateRenderers: function decorateRenderers(renderers, grid) {
    var BodyWrapper = renderers.body.wrapper; // eslint-disable-next-line react/display-name

    renderers.body.wrapper = useMemo(function () {
      return function (props) {
        var _props$listProps = props.listProps,
            listProps = _props$listProps === void 0 ? {} : _props$listProps,
            rows = props.rows;

        var _grid$getInstance = grid.getInstance(),
            hotKeys = _grid$getInstance.hotKeys,
            _grid$getInstance$pro = _grid$getInstance.props,
            autoHeight = _grid$getInstance$pro.autoHeight,
            autoScrollToId = _grid$getInstance$pro.autoScrollToId,
            expandable = _grid$getInstance$pro.expandable,
            overscanCount = _grid$getInstance$pro.overscanCount,
            rowSize = _grid$getInstance$pro.rowSize,
            innerBody = _grid$getInstance.refs.innerBody,
            setHasScroll = _grid$getInstance.setHasScroll,
            filters = _grid$getInstance.state.filters;

        var listRef = useRef();

        var nextListProps = _objectSpread(_objectSpread({}, listProps), {}, {
          ref: mergeRefs(listRef, listProps.ref)
        });

        return /*#__PURE__*/React.createElement(FocusGridManager, {
          hotKeys: hotKeys,
          keyBindings: function keyBindings(_ref) {
            var defaultBindings = _ref.defaultBindings;
            return _objectSpread(_objectSpread({}, defaultBindings), {}, {
              // todo: this is kind of hacky, since it's virtualized and there's
              //  the possibility that the firsts or lasts rows aren't rendered
              Home: runAll(function (e) {
                if (e.ctrlKey) {
                  listRef.current.scrollToItem(0);
                  setTimeout(function () {
                    return defaultBindings.Home(e);
                  }, 10);
                } else {
                  defaultBindings.Home(e);
                }
              }),
              End: runAll(function (e) {
                if (e.ctrlKey) {
                  listRef.current.scrollToItem(rows.length - 1);
                  setTimeout(function () {
                    return defaultBindings.End(e);
                  }, 10);
                } else {
                  defaultBindings.End(e);
                }
              })
            });
          },
          shouldRefocus: false
        }, /*#__PURE__*/React.createElement(VirtualizedBody, _extends({}, props, {
          autoScrollToId: autoScrollToId,
          autoHeight: autoHeight,
          component: BodyWrapper,
          expandable: expandable,
          innerBody: innerBody,
          listProps: nextListProps,
          overscanCount: overscanCount,
          rowSize: rowSize,
          setHasScroll: setHasScroll,
          filters: filters
        })));
      };
    }, [get(grid.getInstance(), 'rows.length')]);
    return renderers;
  }
});

export { VirtualizationPlugin };
//# sourceMappingURL=VirtualizationPlugin.js.map
